import { BellIcon } from '@/components/ui/icons'
import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

import { PageContainer } from '@/components/layout/page-container'
import { ComingSoonCard } from '@/features/account-hub/components/coming-soon-card'

export const Route = createFileRoute('/_app/notifications')({
  component: NotificationsPage,
})

// La ruta renderizaba `<div>Notificaciones — placeholder</div>`: texto plano, sin
// layout ni encabezado, pegado a la esquina del área de contenido. Y es alcanzable
// desde la campana del header, que además muestra punto rojo de no leídas — el
// usuario pulsaba un indicador que promete algo y aterrizaba en la palabra
// "placeholder".
//
// El resto de módulos pendientes ya usaba `ComingSoonCard` (icono + explicación de
// lo que hará + badge "Próximamente"); este simplemente no lo usaba.
function NotificationsPage(): JSX.Element {
  return (
    <PageContainer>
      <header className="mb-6">
        <h1>Notificaciones</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Avisos de vencimientos, timbrado y movimientos de tu cuenta.
        </p>
      </header>
      <ComingSoonCard
        icon={<BellIcon />}
        title="Centro de notificaciones"
        description="Aquí reunirás los avisos de vencimiento de tu CSD, el resultado de cada timbrado y los recordatorios de tus obligaciones fiscales, sin depender del correo."
      />
    </PageContainer>
  )
}
